import * as React from 'react'
import { ArrowLeft, ArrowRight, ChevronsLeft, ChevronsRight, MoreHorizontal } from 'lucide-react'
import { Button } from '@axilon-apps/libs-ui-shadcn'

import type { PaginationItemType } from '../../../../hooks/use-pagination'

export interface Props {
  disabled?: boolean
  onClick: (event: React.MouseEvent, value: number | null) => void
  page: number | null
  selected?: boolean
  type: PaginationItemType
}

export function PaginationItem({
  disabled,
  onClick,
  page,
  selected,
  type
}: Props): React.JSX.Element {
  if (type === 'start-ellipsis' || type === 'end-ellipsis') {
    return (
      <Button variant="outline" size="icon-sm" disabled aria-hidden="true">
        <MoreHorizontal />
      </Button>
    )
  }

  if (type === 'page') {
    return (
      <Button
        variant={selected ? 'default' : 'outline'}
        size="icon-sm"
        disabled={disabled}
        aria-current={selected ? 'page' : undefined}
        onClick={(event) => {
          onClick(event, page)
        }}
      >
        {page}
      </Button>
    )
  }

  const iconsNormalized = {
    first: ChevronsLeft,
    previous: ArrowLeft,
    next: ArrowRight,
    last: ChevronsRight
  } as const

  const labelsNormalized = {
    first: 'First',
    previous: 'Previous',
    next: 'Next',
    last: 'Last'
  } as const

  const Icon = iconsNormalized[type]
  const label = labelsNormalized[type]
  const iconAtStart = type === 'first' || type === 'previous'

  return (
    <Button
      variant="outline"
      size="sm"
      disabled={disabled}
      onClick={(event) => {
        onClick(event, page)
      }}
    >
      {iconAtStart && <Icon />}
      {label}
      {!iconAtStart && <Icon />}
    </Button>
  )
}
